export default {
  navigationBarTitleText: '个人信息'
};
